import { ColumnFilter } from '../Common/ColumnFilter';
export const COLUMNS = [
	{
		Header: 'Date',
		Footer: 'Date',
		accessor: 'transfer_date',
		Filter: ColumnFilter,
	},
	{
		Header: 'Transfer No.',
		Footer: 'Transfer No.',
		accessor: 'transfer_no',
		Filter: ColumnFilter,
	},
	{
		Header: 'From Branch',
		Footer: 'From Branch',
		accessor: 'from_branch_name',
		Filter: ColumnFilter,
	},
	{
		Header: 'To Branch',
		Footer: 'To Branch',
		accessor: 'to_branch_name',
		Filter: ColumnFilter,
	},
	{
		Header: 'Total Items',
		Footer: 'Total Items',
		accessor: 'no_of_items',
		Filter: ColumnFilter,
	},
	{
		Header: 'Total Qty',
		Footer: 'Total Qty',
		accessor: 'total_qty',
		Filter: ColumnFilter,
	},
	{
		Header: 'Total Amount',
		Footer: 'Total Amount',
		accessor: 'total_amount',
		Filter: ColumnFilter,
	},
	{
		Header: 'Narration',
		Footer: 'Narration',
		accessor: 'st_narration',
		Filter: ColumnFilter,
	},
]

export const GROUPED_COLUMNS = [
]
